import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

export const useMyBookings = () => {
  const user = JSON.parse(localStorage.getItem("currentUser"));
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    async function fetchBookings() {
      try {
        const response = await axios.post("/api/bookings/getbookingsbyuserid", {
          userid: user._id,
        });
        setBookings(response.data);
      } catch (error) {
        console.log(error);
      }
    }
    fetchBookings();
  }, [user._id]); // Add 'user._id' to the dependency array

  async function cancelBooking(bookingid, roomid) {
    try {
      const result = await axios.post("/api/bookings/cancelbooking", {
        bookingid,
        roomid,
      });
      console.log(result);
      Swal.fire({
        title: "Success",
        text: "Congratulations, your reservation was cancelled successfully",
        icon: "success",
        confirmButtonText: "OK",
      }).then((result) => {
        window.location.reload();
      });
    } catch (error) {
      console.log(error);
      Swal.fire("Oops, Something went wrong", "error");
    }
  }

  return {
    bookings,
    cancelBooking,
  };
};
